import { DialogLayoutModule } from '@tcc-mono/shared/ui/dialog-layout';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimalSelectionNewAnimalDialogComponent } from './animal-selection-new-animal-dialog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  imports: [
    CommonModule,
    DialogLayoutModule,
    ReactiveFormsModule,
    IonicModule,
    FontAwesomeModule,
    TranslocoModule
  ],
  declarations: [AnimalSelectionNewAnimalDialogComponent],
  exports: [AnimalSelectionNewAnimalDialogComponent]
})
export class AnimalSelectionNewAnimalDialogModule { }
